import { friendlyPhoneFormat } from '@provision/chat-utils';
import { useMemo } from 'react';
import { Client } from 'src/graphql/entities/client';
import { useCtaLabels } from 'src/graphql/entities/client-label';
import { ClientHoverCard } from './client-hover-card';
import { ParticipantPillItem } from './use-conversation-participant-pills';

// Mounted lazily: `ParticipantPill` only renders this inside a closed-by-default
// tooltip Popper, so `useCtaLabels` only fires once a client pill is actually hovered.
export const ClientHoverCardContent = ({ item }: { item: ParticipantPillItem }) => {
  const client: Client | null | undefined = item.participant.client;
  const clientId = client?.clientId ?? '';

  const { ctaLabels } = useCtaLabels(clientId);

  const labels = useMemo(
    () => (ctaLabels ?? []).map((label) => label.labelName).filter(Boolean),
    [ctaLabels],
  );

  if (!client) {
    return null;
  }

  const primaryPhone =
    client.phoneNumbers?.find((phone) => phone.id === client.primaryClientPhoneNumberId) ??
    client.phoneNumbers?.[0];

  return (
    <ClientHoverCard
      name={item.displayName}
      email={client.primaryEmail}
      phone={
        primaryPhone?.number === undefined || primaryPhone.number === null
          ? undefined
          : friendlyPhoneFormat(String(primaryPhone.number))
      }
      labels={labels}
      note={client.notes ?? undefined}
    />
  );
};
